export abstract class AbstractFilter {}
